/**
 * Three.js Library Loader
 * Loads Three.js and OrbitControls from CDN
 */

(function () {
	"use strict";

	// Check if Three.js is already loaded
	if (typeof THREE !== "undefined") {
		console.log("Three.js already loaded");
		initializeOrbitControls();
		return;
	}

	console.log("Loading Three.js...");

	// Load Three.js from CDN
	const threeScript = document.createElement("script");
	threeScript.src =
		"https://cdn.jsdelivr.net/npm/three@0.160.0/build/three.min.js";
	threeScript.async = true;

	threeScript.onload = function () {
		console.log("Three.js loaded successfully");
		initializeOrbitControls();
	};

	threeScript.onerror = function () {
		console.error("Failed to load Three.js");
	};

	document.head.appendChild(threeScript);

	// Load OrbitControls after Three.js
	function initializeOrbitControls() {
		if (typeof THREE === "undefined") {
			console.error("Three.js not loaded, cannot load OrbitControls");
			return;
		}

		// Check if OrbitControls is already available
		if (typeof THREE.OrbitControls !== "undefined") {
			console.log("OrbitControls already available");
			dispatchLoadedEvent();
			return;
		}

		// Load OrbitControls using esm.sh which handles module resolution automatically
		const orbitScript = document.createElement("script");
		orbitScript.type = "module";
		
		// Use esm.sh which automatically resolves "three" import
		orbitScript.textContent = `
			(async function() {
				try {
					// Import OrbitControls from esm.sh - it handles module resolution
					const { OrbitControls } = await import("https://esm.sh/three@0.160.0/examples/jsm/controls/OrbitControls.js");
					
					// Attach to global THREE (UMD build) for compatibility
					if (typeof window.THREE !== "undefined") {
						window.THREE.OrbitControls = OrbitControls;
						console.log("OrbitControls loaded and attached to THREE");
						
						// Dispatch event
						window.dispatchEvent(new CustomEvent("threejs-loaded", {
							detail: {
								three: window.THREE,
								orbitControls: OrbitControls,
							},
						}));
					} else {
						throw new Error("THREE not found in window");
					}
				} catch (error) {
					console.error("Failed to load OrbitControls:", error);
					console.log("3D preview will use basic mouse controls");
					// Dispatch event anyway - basic controls will work
					window.dispatchEvent(new CustomEvent("threejs-loaded", {
						detail: {
							three: window.THREE,
							orbitControls: undefined,
						},
					}));
				}
			})();
		`;

		orbitScript.onerror = function (error) {
			console.error("Failed to execute OrbitControls loader script:", error);
			console.log("3D preview will use basic mouse controls (no OrbitControls)");
			dispatchLoadedEvent();
		};

		document.head.appendChild(orbitScript);

		function dispatchLoadedEvent() {
			const event = new CustomEvent("threejs-loaded", {
				detail: {
					three: THREE,
					orbitControls: THREE.OrbitControls,
				},
			});
			document.dispatchEvent(event);
		}
	}
})();

